import { t } from "ttag";

import { ToolbarButton } from "metabase/common/components/ToolbarButton";
import { useMetabotAgent } from "metabase-enterprise/metabot/hooks";

export const AIDashboardAnalysisButton = () => {
  const { submitInput } = useMetabotAgent();

  const handleClick = () => submitInput("Analyze this Dashboard");

  const tooltipLabel = t`Explain this dashboard`;

  return (
    <ToolbarButton
      aria-label={tooltipLabel}
      tooltipLabel={tooltipLabel}
      icon={"metabot_sad"}
      onClick={handleClick}
    />
  );
};
